<script lang="ts">
    import {fly} from 'svelte/transition'

    export let scrolled: boolean
    export let savedWordsCount: number
</script>

<div id="word-count"
     data-testid="saved-words-count"
>
    {#key savedWordsCount}
        <div in:fly|global="{{ y: 10, duration: 700 }}">
            {savedWordsCount.toLocaleString()}&nbsp;
        </div>
    {/key}
    <div class="txt" class:shrink={scrolled}>{savedWordsCount === 1 ? 'word' : 'words'} saved</div>
</div>

<style>

    #word-count {
        display: flex;
        margin-bottom: .2rem;
    }

    #word-count div:first-child {
        font-weight: bold;
    }

    .txt {
        width: 6.2rem;
        white-space: nowrap;
        transition: width 400ms;
        overflow: hidden;
        /*border: 1px solid teal;*/
    }

    .shrink {
        width: 0;
    }
</style>